<!--移动端埋点检查下的全部字段-->
<template>
    <div class="mobile-note-all">
        <el-table
            :data="getDataList"
            border
            style="width: 100%">
            <el-table-column
                type="index"
                :index="indexMethod">
            </el-table-column>
            <el-table-column
                prop="fieldName">
                <span slot="header" slot-scope="scope">
                    <el-input
                        v-model="searchNotekey"
                        size="mini"
                        style="width: auto"
                        suffix-icon="el-icon-search"
                        placeholder="字段名称"
                        clearable
                        @input="noteSearch"/>
                </span>
            </el-table-column>
            <el-table-column
                prop="fieldValue"
                label="字段值">
            </el-table-column>
            <el-table-column
                prop="fieldDes"
                label="字段说明">
            </el-table-column>
            <el-table-column
                v-if="isApp"
                prop="fieldObt"
                label="获取方式">
            </el-table-column>
        </el-table>
    </div>

</template>

<script>
    export default {
        name: "mobile-noteall",
        props: {
            detailData: Array,
            isApp: Boolean
        },

        data() {
            return {
                searchNotekey: '',
                originalData: []
            }
        },

        computed: {
            getDataList() {
                this.originalData = this.detailData;
                return this.getMobileDataList(this.searchNotekey);
            },
        },

        methods: {
            indexMethod(index) {
                return index + 1;
            },

            getMobileDataList(key) { // 设置表单数据
                let emptyArray = [];
                let emptyStr = this.checkKeyword(key);
                if (emptyStr) {
                    emptyArray = this.originalData;
                } else {
                    for (let len = this.originalData.length, j = len - 1; j >= 0; j--) {
                        let item = this.originalData[j];
                        if (item.fieldName.indexOf(key) != -1) {
                            emptyArray.push(item);
                        }
                    }
                }
                return emptyArray;
            },

            checkKeyword(str) {  // 统一处理返回的数据
                if (str == "" || str == undefined || str == null) return true;
                let reg = "^[ ]+$";
                let re = new RegExp(reg);
                return re.test(str);
            },

            noteSearch() {
                this.getMobileDataList(this.searchNotekey);
            }
        }
    }
</script>

<style lang="scss">
    .mobile-note-all {

    }
</style>

